module.exports = __webpack_public_path__ + "img/glazing_double.a2bd32f.svg";